import { Material } from '@/models/Material';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component<AddPercentageDialog>({})
export default class AddPercentageDialog extends Vue {
  @Prop()
  protected selectedMaterial!: Material;

  protected selectedPercentage = 0;

  public mounted() {
    if (this.selectedMaterial && this.selectedMaterial.percentage) {
      this.selectedPercentage = Number(this.selectedMaterial.percentage);
    }
  }

  protected handleChangePercentage() {
    if (this.selectedPercentage > 100) {
      this.selectedPercentage = 100;
    }

    if (this.selectedPercentage < 0) {
      this.selectedPercentage = 0;
    }
  }

  @Emit()
  protected close(): string {
    return '';
  }

  @Emit()
  protected save(): Material {
    this.selectedMaterial.percentage = this.selectedPercentage;

    return this.selectedMaterial;
  }
}
